var exports = {
  "j": "ErrorFlash__CcD-ho",
  "Y": "ErrorOcticon__PHKHIT",
};

module.exports = exports;
